import React , { useEffect } from 'react'
import { connect } from 'react-redux'
import { verifyDocumentCredability } from '../../redux/verify-document-credability/verify-document-credability.actions'
import { validateDocument } from '../../redux/validate-document/validate-document.actions'
import { createLoadingSelector } from '../../redux/loading/loading.selectors'
import { createErrorMessageSelector } from '../../redux/error/error.selectors'
import WithSpinner from '../with-spinner/with-spinner.component'
import { VerifyFailureComponent } from '../verify-failure/verify-failure.component'
import VerifySuccessComponent from '../verify-success/verify-success.component'


const errorSelector = createErrorMessageSelector(['VALIDATE_DOCUMENT', 'VERIFY_DOCUMENT_CREDABILITY'])
const loadingSelector = createLoadingSelector(['VALIDATE_DOCUMENT', 'VERIFY_DOCUMENT_CREDABILITY'])

// ovo mozda staviti u wrapper

const VerifyDocumentCredibility = ({ verifyDocumentCredability, validateDocument, match, verifyCredability, isLoading, error, ...otherProps }) => {
  let { verificationCode } = match.params

  useEffect(() => {
    if(verificationCode && !verifyCredability) {
      verifyDocumentCredability(verificationCode)

    }
  },[verificationCode, verifyDocumentCredability, verifyCredability])

  if(verifyCredability) {    
    const { dateSigned, documentDownloadLink, fileName} = verifyCredability
    return (
      <div>
        { ( dateSigned && documentDownloadLink && fileName) ? <VerifySuccessComponent dateSigned={dateSigned} downloadLink={documentDownloadLink} fileName={fileName} validateDocument={validateDocument}/> : <VerifyFailureComponent />}
      
      </div>
    )
  }
  return <div></div>
   
 }
 
 const mapStateToProps = (state) => ({
   isLoading: loadingSelector(state),
   error: errorSelector(state),
   verifyCredability: state.verifyCredability
 })
 
 const mapDispatchToProps = dispatch => ({
  verifyDocumentCredability: verificationCode => dispatch(verifyDocumentCredability(verificationCode)),
  validateDocument: params => dispatch(validateDocument(params))
 })
 
 
 export default connect(mapStateToProps, mapDispatchToProps)(WithSpinner(VerifyDocumentCredibility))

